import { useState } from 'react'
import { Head, router, usePage } from '@inertiajs/react'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Label } from '@/components/ui/Label'
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from '@/components/ui/Card'
import { KeyRound } from 'lucide-react'
import { AuthBackground } from '@/components/auth/AuthBackground'

export default function ForgotPassword() {
  const { flash } = usePage<{ flash: { notice?: string } }>().props
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [email, setEmail] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)
    router.post('/password', { user: { email } }, {
      onFinish: () => setIsSubmitting(false),
    })
  }

  return (
    <>
      <Head title="Forgot Password" />

      <AuthBackground>
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <KeyRound className="size-12 text-primary mx-auto mb-2" />
            <CardTitle>Reset your password</CardTitle>
            <CardDescription>Enter your email and we'll send reset instructions</CardDescription>
          </CardHeader>

          <CardContent>
            {flash?.notice && (
              <div className="mb-4 p-3 rounded-lg bg-primary/10 text-sm text-primary">
                {flash.notice}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="ghost@example.com"
                  required
                />
              </div>

              <Button type="submit" className="w-full cursor-pointer" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send reset instructions'}
              </Button>
            </form>
          </CardContent>

          <CardFooter className="justify-center">
            <a href="/login" className="text-sm text-muted-foreground hover:text-foreground cursor-pointer">
              Back to login
            </a>
          </CardFooter>
        </Card>
      </AuthBackground>
    </>
  )
}
